/* eslint-disable no-undef */
import MapDeleteButtonOverlay from 'js/components/map/MapDeleteButtonOverlay';

const LineDeleteButton = ({ position, map, onClick, center = false }) => {
    const getPixelPosition = (divPosition, offsetX, offsetY) => {
        return center
            ? { x: divPosition.x, y: divPosition.y }
            : { x: divPosition.x - offsetX, y: divPosition.y - offsetY };
    };

    return (
        <MapDeleteButtonOverlay
            map={map}
            position={position}
            onClick={onClick}
            getPixelPosition={getPixelPosition}
        />
    );
};

export default LineDeleteButton;
